import React, { FunctionComponent } from 'react';

interface IConditionalWrapProps {
    condition: boolean;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    wrap: Function;
    children: React.ReactNode;
}

const ConditionalWrapper: FunctionComponent<IConditionalWrapProps> = ({
    condition,
    wrap,
    children,
}) => (condition ? wrap(children) : <>{children}</>);

export default ConditionalWrapper;